import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { SquadCastModule } from './app/squadcast.app.module';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(SquadCastModule);
